// AI艺术创作
const jmRoutes = Array.from({ length: 9 }, (_, i) => ({
  path: `create/jm/index${i + 1}`,
  name: `create/jm/Index${i + 1}`,
  component: () => import(`@/views/smartLife/create/jm/index${i + 1}.vue`)
}))
const branch1jmRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `create/jm/branch1/index${i + 1}`,
  name: `create/jm/branch1/Index${i + 1}`,
  component: () => import(`@/views/smartLife/create/jm/branch1/index${i + 1}.vue`)
}))
const branch2jmRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `create/jm/branch2/index${i + 1}`,
  name: `create/jm/branch2/Index${i + 1}`,
  component: () => import(`@/views/smartLife/create/jm/branch2/index${i + 1}.vue`)
}))

const dbRoutes = Array.from({ length: 29 }, (_, i) => ({
  path: `create/db/index${i + 1}`,
  name: `create/db/Index${i + 1}`,
  component: () => import(`@/views/smartLife/create/db/index${i + 1}.vue`)
}))

import createIndex from '@/views/smartLife/create/index'



export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'create/index',
        name: 'createIndex',
        component: createIndex
      },
    // AI艺术创作，开始
    ...jmRoutes,
    ...branch1jmRoutes,
    ...branch2jmRoutes,
    ...dbRoutes,
    // AI艺术创作，结束


  ],
};
